<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const SectionList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Permissions/Sections/List/Wrapper'));
const AddButton = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Permissions/Sections/AddButton'))

const router = useRouter();
const { t } = useI18n();

// Store
const applicationStore = useApplicationStore();

const currentApplication = computed(() => applicationStore.getCurrent);

const { authUser, authUserHasPermission } = useAuthUser({});
const allowed = ref(false);

onMounted(() => {

    const canConsult = (authUserHasPermission('consult permissions'));
    if(! canConsult) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        document.title = t('page.admin.permissions.sections.list.title') + ' - ' + currentApplication.value.name;
        allowed.value = true;
    }
});
</script>

<template>
    <layout v-if="allowed">
        <div class="content_header">
            <div class="content-header_title">
                <h1 class="first-title">{{ $t('page.admin.permissions.sections.list.title') }}</h1>
                <p>{{ $t('page.admin.permissions.sections.list.description') }}</p>
            </div>
            <div class="content-header_btn">
                <add-button v-if="authUserHasPermission('create permission')">
                    {{ $t('page.admin.permissions.sections.list.create.button.label') }}
                </add-button>
            </div>
        </div>

        <p class="generic-message generic-message-warning">
            {{ $t('page.admin.permissions.sections.list.warning') }}
        </p>

        <section-list></section-list>
    </layout>
</template>
